<template>
<div>
    <!-- SelectList :label="$t('infopoints.timetable_view')" :options="timetableViewOptions" :value="timetableViewValue" @select="onSelectView" :disabled="loading"/ -->
    <SelectList :label="$t('sse_displays.layout')" :options="layoutOptions" :value="layoutValue" @select="onSelectLayout" :disabled="loading"/>
    
    <div class="show-layouts"><label>{{ $t('sse_displays.all_layouts') }}</label><input type="checkbox" v-model="showAllLayouts"></div>

    <p-button v-if="true" :disabled="!selectionsChanged || OK || ERROR" @click="save" type="success" size="sm" outline><i class="fa fa-check"></i><span>{{ $t('button.save') }}</span></p-button>
 
    <RequestInfo type="save" :ok="OK" :error="ERROR" :loader="loading" />
  
</div>
</template>


<script>
//import display from '@/store/displays/display'
import sseDisplay from '@/store/displays/sseDisplay'

export default {
    props: ['item'], 
    data: function() {
        return {
            //viewSelection: "",
            layoutSelection: "",
            loading: false,
            OK: false,
            ERROR: false,
            showAllLayouts: true
        }
    },
    computed: {
        display() {
            return this.item;
        },
        /*timetableViews() {
            return this.$store.state.infopoint.timetableViews;
        },
        timetableViewOptions(){
            var optionList = [];
            for (var item of this.$store.state.display.displayList) {
                optionList.push({ id: item.id, label: item.id + " - " + item.name })
            }
            return optionList;
        },*/
        layoutOptions() {
            var optionList = [];
            for (var layout of this.$store.state.sseDisplay.layouts) {
                if (this.showAllLayouts) {
                    optionList.push({ id: layout.displayLayoutId, label: layout.layoutName });
                }
                else {
                    if (layout.usage > 0) optionList.push({ id: layout.displayLayoutId, label: layout.layoutName })
                }
            }
            return optionList;
        },
        /*timetableViewValue(){
            return (this.infopointContent && this.infopointContent[0]) ?  this.infopointContent[0].timetableView : "";
        },*/
        layoutValue() {
            return (this.item && this.item.configuration && this.item.configuration.display_layout_id) ? 
                this.item.configuration.display_layout_id : "";
        },
        selectionsChanged() {
            return (this.layoutSelection != this.layoutValue);
        }
    },
    watch: {
       display() {
           this.getDisplayContent();
        }
    },
    methods: {
        save() {
            this.loading = true;
            this.$store.dispatch('sseDisplay/setLayout', {
                    "deviceid": this.item.deviceId, "layoutid": this.layoutSelection
                }).then(response => {
                if (response.data.errorCode == 0) {
                    //this.displayContent[0].timetableView = infopointnaytto.timetableView; 
                    this.item.configuration.display_layout_id = this.layoutSelection;
                    this.OK = true;
                    this.$store.dispatch('sseDisplay/getLayouts');
                }
                else {
                    this.ERROR = true;
                    //this.viewSelection = this.timetableViewValue;
                    this.layoutSelection = this.layoutValue;
                }
            })
            .catch(() => { this.ERROR = true; })
            .finally(() => { this.loading = false; });
        },
        /*onSelectView(id) {
           this.viewSelection = id;
           this.clearAlerts();
        },*/
        onSelectLayout(id) {
            this.layoutSelection = id;
            this.clearAlerts();
        },
        clearAlerts() {
            this.OK = this.ERROR = false;
        },
        getDisplayContent() {
            if (this.display) {
                this.layoutSelection = this.layoutValue;
            }
            this.clearAlerts();
        }    
    },
    created() {
        /*if (!this.$store.state.display) this.$store.registerModule("display", display);
        this.$store.dispatch('display/getDisplayList');
        */
        if (!this.$store.state.sseDisplay) {
             this.$store.registerModule("sseDisplay", sseDisplay);
        }
        this.$store.dispatch('sseDisplay/getLayouts');
        this.getDisplayContent();
    }
}
</script>

<style scoped lang="scss">
    .show-layouts {
        float: right;
        display: flex; 
        align-items: center; 
    
        label {
            margin-right: 4px;
            margin-bottom: 0;
        }
    }
</style>